import DetailLog from './DetailLog';

export default DetailLog;
